import Index from './index.vue'
const InventoryList = () => import("@/modules/ReportView/components/inventory/InventoryList.vue");
const AvailableSerial = () => import("@/modules/ReportView/components/inventory/AvailableSerial.vue");

export default [{
  path: 'inventory',
  name: 'inventory',
  component: Index,
  redirect: {
    name: 'inventory-list'
  },
  children: [{
      path: 'serial',
      name: 'inventory-list',
      component: InventoryList,
    },
    {
      path: 'availableSerial',
      name: 'available-serial',
      component: AvailableSerial,
    },
  ],

}, ]